import firebase from '../config/firebase.config';
import httpClient from '../config/httpClient';

async function getAuthHeaders() {
  const user = firebase.auth().currentUser;
  if (!user) throw new Error('User not authenticated');
  const idToken = await user.getIdToken();
  return { Authorization: `Bearer ${idToken}` };
}

async function getAppDownloadConfig() {
  const headers = await getAuthHeaders();
  const response = await httpClient.get('/getAppDownloadConfig', { headers });
  return response.data;
}

async function publishAppDownloadUrl({
  platform,
  downloadUrl,
  currentVersion,
}) {
  const headers = await getAuthHeaders();
  const response = await httpClient.post(
    '/publishAppDownloadUrl',
    { platform, downloadUrl, currentVersion },
    { headers }
  );
  return response.data;
}

export default {
  getAppDownloadConfig,
  publishAppDownloadUrl,
};
